import ConstructorIO from '@constructor-io/constructorio-client-javascript';

let client = null;

// Lazy singleton: window.cnstrc.indexKey (set server-side, same key
// product-grid.js's CioPlp already uses) isn't guaranteed to exist at
// module-eval time, so the client is built on first use, not on import.
export default function getConstructorBrowseClient() {
  if (!client) {
    client = new ConstructorIO({ apiKey: window.cnstrc?.indexKey });
  }
  return client;
}
